import styled from 'styled-components';

// Components
import Preset from './Preset';

const PrimePresets = ({
  presets,
  setDefaultPreset,
  agGridApi,
  is_active,
  onLoad
}) => {
  return (
    <Container>
      {presets.map((preset, i) => {
        return (
          <Preset 
            setDefaultPreset={setDefaultPreset}
            key={i} 
            index={i}
            is_active={is_active}
            agGridApi={agGridApi}
            onLoad={onLoad}
            {...preset}/>
        )
      })}
    </Container>
  );
};

export default PrimePresets;

const Container = styled.div`
  height: 100%;
`